export default "__VITE_ASSET__O$vFSf$L__"